import "./WithdrawHewePage.scss";
import { ChooseTab } from "./components";

const WithdrawHewePage = () => {
  return (
    <div className="WithdrawHewePage">
      <ChooseTab />
    </div>
  );
};

export default WithdrawHewePage;
